import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Banknote, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { money } from "@/lib/format";

// Claim = pay out what's actually available in the Stripe Connect balance to the bank.
export const ClaimPanel = ({ base = "/enhancer", testid = "claim-panel" }) => {
  const qc = useQueryClient();
  const [busy, setBusy] = useState(false);
  const { data } = useQuery({ queryKey: ["claim-info", base], queryFn: () => api.get(`${base}/connect/claim-info`).then((r) => r.data) });
  if (!data) return null;
  const claim = async () => {
    setBusy(true);
    try {
      const { data: r } = await api.post(`${base}/connect/claim`);
      toast.success(`${money(r.amount)} is on its way to your bank${r.arrival_date ? ` — expected ${r.arrival_date}` : ""}.`);
      qc.invalidateQueries({ queryKey: ["claim-info", base] });
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <div className="eyw-card p-5 mt-6" data-testid={testid}>
      <p className="eyw-label mb-3 flex items-center gap-1"><Banknote size={13} /> Commissions</p>
      <div className="grid sm:grid-cols-3 gap-4 text-sm">
        <div><p className="text-xs text-[#8FA89B]">Available to claim</p><p className="font-serif text-2xl text-[#144F75]" data-testid={`${testid}-available`}>{data.available == null ? "—" : money(data.available)}</p></div>
        <div><p className="text-xs text-[#8FA89B]">Settling in Stripe</p><p className="font-serif text-2xl text-[#1A242B]" data-testid={`${testid}-pending`}>{data.pending == null ? "—" : money(data.pending)}</p>
          {data.next_available_on && <p className="text-xs text-[#8FA89B]" data-testid={`${testid}-eta`}>est. available {data.next_available_on}{data.last_available_on && data.last_available_on !== data.next_available_on ? ` – ${data.last_available_on}` : ""}</p>}</div>
        <div><p className="text-xs text-[#8FA89B]">Still owed by EYW</p><p className="font-serif text-2xl text-[#1A242B]" data-testid={`${testid}-owed`}>{money(data.owed_by_eyw || 0)}</p><p className="text-xs text-[#8FA89B]">sent on the payout schedule</p></div>
      </div>
      <button onClick={claim} disabled={!data.can_claim || busy} className="eyw-btn mt-4 disabled:opacity-50" data-testid={`${testid}-btn`}>
        {busy && <Loader2 className="animate-spin" size={16} />} Claim to bank
      </button>
      {!data.can_claim && data.reason && <p className="text-xs text-[#b8694f] mt-2" data-testid={`${testid}-reason`}>{data.reason}</p>}
    </div>
  );
};
